/** 已布置给当前孩子的学习：进行中 → 待完成 → 已完成，未完成的可以撤回 */
import { ListChecks, Undo2 } from "lucide-react";
import { useMemo, useState } from "react";
import { TaskEditSheet } from "../../components/TaskEditSheet";
import { type Assignment, confirm, deleteEntity, run, select, shallowEqual, useCalendar, useCurrentChild, useStore } from "../../core";
import { ChildSwitcher, EmptyHint, Pill } from "../../ui";
import { assignmentWhen, isPending, sortAssignments, statusLabel } from "./activity";
import { TypeBlock } from "./Library";

export function AssignedList() {
  const child = useCurrentChild();
  const childId = child?.id ?? "";
  const assignments = useStore((s) => select.assignmentsOf(s, childId), shallowEqual);
  const list = useMemo(() => sortAssignments(assignments), [assignments]);
  const [editing, setEditing] = useState<string | null>(null);

  return (
    <>
      <div>
        <ChildSwitcher />
      </div>
      {list.length === 0 ? (
        <EmptyHint icon={ListChecks} text="还没有布置学习" />
      ) : (
        <div className="learn-list">
          {list.map((a) => (
            <AssignedRow key={a.id} a={a} onEdit={() => setEditing(a.id)} />
          ))}
        </div>
      )}
      <TaskEditSheet assignmentId={editing} onClose={() => setEditing(null)} />
    </>
  );
}

function AssignedRow({ a, onEdit }: { a: Assignment; onEdit: () => void }) {
  const content = useStore((s) => s.contents[a.contentId]);
  const event = useStore((s) => (a.scheduleEventId ? s.scheduleEvents[a.scheduleEventId] : undefined));
  const cal = useCalendar();
  const st = statusLabel(a);

  const revoke = async () => {
    const ok = await confirm({ title: "撤回这个学习安排？", message: content ? `「${content.title}」会从孩子的学习列表里移除。` : undefined, confirmText: "撤回", danger: true });
    if (!ok) return;
    await run(() => deleteEntity("assignments", a.id, `assignments/${a.id}`), "已撤回");
  };

  return (
    <div className="learn-row is-static" data-testid="assigned-row">
      <TypeBlock type={content?.activityType ?? ""} />
      <div className="learn-row-main" role={isPending(a) ? "button" : undefined} tabIndex={isPending(a) ? 0 : undefined} style={isPending(a) ? { cursor: "pointer" } : undefined} title={isPending(a) ? "改时间、截止、奖励" : undefined} onClick={isPending(a) ? onEdit : undefined}>
        <strong>{content?.title ?? "已删除的内容"}</strong>
        <span>{assignmentWhen(a, event, cal)}</span>
      </div>
      <Pill tint={st.tint} ink={st.ink} size={12}>
        {st.text}
      </Pill>
      {isPending(a) && (
        <button type="button" className="learn-revoke" aria-label="撤回" title="撤回" onClick={() => void revoke()}>
          <Undo2 size={15} strokeWidth={2.6} />
        </button>
      )}
    </div>
  );
}
